/*
 * Public API Surface of ngx-lib/list
 */
export * from './list.module';
export * from './list.component';
